export enum CustomFieldKind {
    ShowOnEmployeeFiche = 0,
    ShowOnCandidateFiche = 1,
    ShowOnEmployeeAndCandidateFiche = 2
}